module.exports = __webpack_public_path__ + "img/grip4.13b58bed.png";